import { createGlobalState } from 'react-use';
import { useCallback } from 'react';
const isOldState = (data) => {
    return 'state' in data && 'version' in data;
};
const readLocalStorage = {
    name: 'useAnnouncementPopover',
    getData: function () {
        var _a;
        if (typeof window === 'undefined') {
            return {};
        }
        try {
            const dataStr = window.localStorage.getItem(this.name);
            const data = dataStr
                ? JSON.parse(dataStr)
                : {};
            return isOldState(data) ? ((_a = data.state) === null || _a === void 0 ? void 0 : _a.readMap) || {} : data;
        }
        catch (e) {
            return {};
        }
    },
    setData: function (newData) {
        if (typeof window === 'undefined') {
            return {};
        }
        try {
            window.localStorage.setItem(this.name, JSON.stringify(newData));
        }
        catch (e) { }
    },
};
const useGlobalReadState = createGlobalState(typeof window === 'undefined' ? {} : readLocalStorage.getData());
export const useReadState = () => {
    const [globalReadState, setGlobalReadState] = useGlobalReadState();
    return [
        globalReadState,
        useCallback((ids, bool) => {
            if (typeof window === 'undefined') {
                return;
            }
            const idList = typeof ids === 'object' ? ids : [ids];
            const newState = {
                ...globalReadState,
                ...Object.fromEntries(idList.map((id) => [id, bool])),
            };
            setGlobalReadState(newState);
            readLocalStorage.setData(newState);
        }, [globalReadState, setGlobalReadState]),
    ];
};
